export const LOGIN_STATE = "login_state";
export const USER_INFO = "user_info";
export const MESSAGE_CHANNEL = "modal-message";
export const TOKEN = 'user_token'
